export const iconFontAwesomeLogisticsAnchorCircleExclamation = (
	<i className="fa-solid fa-anchor-circle-exclamation"></i>
);
